import React from 'react'
import CreateAccountComp from './components/create_account_comp'
import PageComponent from '../../components/page/page_comp'

const CreateAccountPage = () => {
  return (
    PageComponent({
      content: <CreateAccountComp />,
      showFooter: false,
    })
  )
}

export default CreateAccountPage